import EvaluationsHeader from './EvaluationsHeader';
import EvaluationsReplacements from './EvaluationsReplacements';
import { Card, Flex, Space, Typography } from 'antd';
import { DeleteButton, EditButton } from '@refinedev/antd';
import { IClassroomEvaluation } from 'interfaces/classrooms';
import { ResponseError } from '../../interfaces/api-error';
import { useCan } from '@refinedev/core';

interface EvaluationProps {
  evaluationData: IClassroomEvaluation;
  resource: string;
  evaluationEditModal: (evaluationId: string) => void;
  replacementCreateModal: (id: string) => void;
  replacementEditModal: (parentId: string, replacementId: string) => void;
  replacementAssociationModalShow: (replacementId: string) => void;
}

export const kindMap = {
  final: 'Prova final',
  replacement: 'Avaliação substitutiva',
  regular: 'Avaliação padrão'
};

const Evaluation = ({
  evaluationData,
  resource,
  evaluationEditModal,
  replacementCreateModal,
  replacementEditModal,
  replacementAssociationModalShow
}: EvaluationProps) => {
  const { data: canDeleteEvaluation } = useCan({
    resource: 'classroom_evaluations',
    action: 'delete'
  });
  const { data: canDeleteClassroom } = useCan({
    resource: 'classrooms',
    action: 'delete'
  });
  const canDelete = Boolean(
    canDeleteEvaluation?.can || canDeleteClassroom?.can
  );

  return (
    <Card
      type="inner"
      className="w-full p-0"
      size="small"
      styles={{
        body: {
          padding: 0
        }
      }}
      title={
        <Space>
          <Typography.Text className="text-slate-700 text-base font-normal">
            {evaluationData.name}
          </Typography.Text>
          <Typography.Text className="text-gray-500 text-sm font-normal">
            {kindMap[evaluationData.kind]}
          </Typography.Text>
        </Space>
      }
    >
      <Flex className="p-4 border-b border-gray-100" justify="space-between">
        <EvaluationsHeader evaluationData={evaluationData} />

        <Space>
          <DeleteButton
            className="self-end"
            hideText
            size="small"
            resource={`${resource}`}
            accessControl={{ enabled: false }}
            disabled={!canDelete}
            recordItemId={evaluationData.id}
            errorNotification={error => {
              const err = error as unknown as ResponseError;

              const errorMessage = err?.message;

              return {
                type: 'error',
                description: 'Ops!',
                message: `Erro ao excluir: ${
                  errorMessage || 'Erro desconhecido'
                }`
              };
            }}
          />

          <EditButton
            hideText
            size="small"
            recordItemId={evaluationData.id}
            onClick={e => {
              e.stopPropagation();
              evaluationEditModal(evaluationData.id);
            }}
          />
        </Space>
      </Flex>

      <EvaluationsReplacements
        evaluationData={evaluationData}
        resource={resource}
        replacementCreateModal={replacementCreateModal}
        replacementEditModal={replacementEditModal}
        replacementAssociationModalShow={replacementAssociationModalShow}
      />
    </Card>
  );
};

export default Evaluation;
